module.exports = __webpack_public_path__ + "static/media/search-icon.f57d4705.svg";